import { useSearchParams } from 'react-router-dom'

import css from './NoResult.module.css'

import { Config } from '#/global/helper/Config'

const i18n = {
    cz: {
        title: (query: string) => (
            <>
                Pro frázi
                {' '}
                <b>
                    &quot;
                    {query}
                    &quot;
                </b>
                {' '}
                nebyl nalezen žádný výsledek.
            </>
        ),
        subtitle: 'Tipy k hledání',
        typ1: 'Zkontrolujte, zda jste hledaný výraz napsali správně.',
        typ2: 'Zkuste použít podobné nebo obecnější klíčové slovo.',
        typ3: (email: string) => (
            <>
                Napište nám na
                {' '}
                <a className={css.link} href={`mailto:${email}`}>
                    {email}
                </a>
                , co hledáte.
                { }
            </>
        ),
    },
    sk: {
        title: (query: string) => (
            <>
                Pre frázu
                {' '}
                <b>
                    &quot;
                    {query}
                    &quot;
                </b>
                {' '}
                nebol nájdený žiadny výsledok.
            </>
        ),
        subtitle: 'Tipy k hľadaniu',
        typ1: 'Skontrolujte, či ste hľadaný výraz napísali správne.',
        typ2: 'Skúste použiť podobné alebo všeobecnejšie kľúčové slovo.',
        typ3: (email: string) => (
            <>
                Napíšte nám na
                {' '}
                <a className={css.link} href={`mailto:${email}`}>
                    {email}
                </a>
                , čo hľadáte.
                { }
            </>
        ),
    },
}

export const NoResult = () => {
    const [searchParameters] = useSearchParams()
    const query = searchParameters.get('query') ?? ''

    const t = i18n[Config.getLang()]

    const email = Config.getEmail()

    return (
        <div className={css.container}>
            <div>
                <img
                    className={css.image}
                    src="https://cdn1.idek.cz/file/noSearchResult-192cead7.svg"
                    width={127}
                    height={127}
                />
            </div>
            <div>
                <div className={css.title}>{t.title(query)}</div>
                <div>
                    <div className={css.subtitle}>
                        <b>{t.subtitle}</b>
                    </div>
                    <div>
                        <ul className={css.list}>
                            <li>{t.typ1}</li>
                            <li>{t.typ2}</li>
                            <li>{t.typ3(email)}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
